import _ from 'lodash';
import * as React from 'react';
import { fetchProtectedImageAsDataUrl } from 'common/utils/image-utils';
import { firstUpperWords } from '../../utils/generic';
import { Text } from '../texts';
import { Styled } from './styled';

export const Avatar = (props) => {
  const { size, avatar, name, onClick } = props;
  const [imageUrl, setImageUrl] = React.useState(null);
  // eslint-disable-next-line lodash/prefer-lodash-method
  const shortName = name && firstUpperWords(name.replace(/\s{2,}/g, ' ').trim(), 2);

  React.useEffect(() => {
    if (!avatar) {
      setImageUrl(null);
      return undefined;
    }

    if (_.startsWith(avatar, 'data:')) {
      setImageUrl(avatar);
      return undefined;
    }

    let cancelled = false;
    fetchProtectedImageAsDataUrl(avatar).then(dataUrl => {
      if (!cancelled) {
        setImageUrl(dataUrl);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [avatar]);

  const showInitials = !avatar || !imageUrl;

  return (
    <Styled.Avatar size={size} onClick={onClick && onClick} url={imageUrl}>
      {showInitials && (
        <Text color={'white'} fontSize={size * 0.35} font="Medium">
          {shortName}
        </Text>
      )}
    </Styled.Avatar>
  );
};
